export enum DemandDataBasis {
    DYNAMIC = 'DYNAMIC',
    STATIC = 'STATIC',
}
